import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { trNowLocalDateInput } from '../../utils/trDateTime';

/**
 * SidebarWeeklyHeatmap — 7-day activity circles in sidebar.
 *
 * Props:
 *   weeklyData — array of { date, lessons, minutes } (last 7 days, oldest first)
 */
export default function SidebarWeeklyHeatmap({ weeklyData = [] }) {
  const { t } = useLanguage();

  // Build 7-day display: if weeklyData shorter, pad with inactive days
  const days = [];
  const todayTrStr = trNowLocalDateInput();
  for (let i = 6; i >= 0; i--) {
    const d = new Date(`${todayTrStr}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() - i);
    const dateStr = d.toISOString().slice(0, 10);
    const match = weeklyData.find(w => (w.date || '').slice(0, 10) === dateStr);
    const active = match && (match.lessons > 0 || match.minutes > 0);
    days.push({ date: d, dateStr, active, data: match || null });
  }

  const dayLabels = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  // Detect locale for short day names — use built-in date format
  const getDayLabel = (date) => {
    try {
      return date.toLocaleDateString('default', { weekday: 'short' }).slice(0, 2);
    } catch {
      return dayLabels[date.getDay()];
    }
  };

  return (
    <div className="card-duo p-[18px]" data-testid="sidebar-weekly-heatmap">
      <h3 className="font-duo-display text-[15px] text-[#0E1F3D] mb-3.5">
        {t('dashboard.duo.thisWeek')}
      </h3>
      <div className="flex justify-between items-end">
        {days.map(({ date, dateStr, active }) => (
          <div key={dateStr} className="flex flex-col items-center gap-1.5">
            <div
              className={`w-[30px] h-[30px] rounded-full flex items-center justify-center transition-colors ${
                active
                  ? 'bg-[#34CC67]'
                  : 'bg-[#f2f5f3] border border-[#e7ece8]'
              }`}
              aria-label={`${getDayLabel(date)} — ${active ? t('dashboard.duo.studied') : t('dashboard.duo.notStudied')}`}
              role="img"
            >
              {active && (
                <CheckCircle2 size={15} strokeWidth={2.5} className="text-white" aria-hidden="true" />
              )}
            </div>
            <span className="text-[11px] font-semibold text-[#8a978d]">
              {getDayLabel(date)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
